import LibraryCard from '@views/library/card';
import LibraryIndex from '@/views/library/index';
import LibraryShow from '@/views/library/show';
import LibraryList from '@/views/library/list';

export default [
  {
    path: '/library',
    name: 'library#index',
    component: LibraryIndex,
    meta: {
      disableSearchbar: true,
    },
  },
  {
    path: '/library/list',
    name: 'library#list',
    component: LibraryList,
    meta: {
      masteryHeader: true,
    },
  },
  {
    path: '/library/decks/:deckId/:cardId?',
    name: 'library#card',
    component: LibraryCard,
    meta: {
      masteryHeader: true,
    },
  },
  {
    path: '/library/:assetType/:assetId',
    name: 'library#show',
    component: LibraryShow,
  },
];
